import * as angular from 'angular';
import {IController} from "angular";
import {$viewSettingsFactory} from "../../$viewSettings.factory";

export class BringozQuickFilterDisplayValueCtrl implements IController {
  id: any;

  private quickFiltersRef: any;
  private selectedQuickFilter: any;

  /* @ngInject */
  constructor(private $viewSettings: $viewSettingsFactory, private $log) {
    this.quickFiltersRef = this.$viewSettings();
  }

  $onInit() {
    this.setItem(this.id);
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.setItem(this.id);
    }
  }

  private setItem(id) {
    if (id) {
      this.quickFiltersRef.$asyncValues([id])
        .then((quickFilters) => {
          this.selectedQuickFilter = quickFilters[0];
        })
        .catch((error) => {
          this.$log.error('Failed to get quick filters', error);
        })
    } else {
      this.selectedQuickFilter = undefined;
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozQuickFilterDisplayValue', {
    bindings: {
      id: '<',
      onChange: '&'
    },
    template: require('./bringoz-quick-filter-display-value.html').default,
    controller: BringozQuickFilterDisplayValueCtrl
  });
